import styled from 'styled-components';
import { ButtonTag } from '../../components/Button/styles';

export const ShareSection = styled.section`
  margin-top: 125px;

  @media (min-width: 768px) {
    margin-bottom: 50px;
  }
  
  @media (min-width: 1110px) {
    margin-top: 100px;
    margin-bottom: 0;
  }
`;

export const ShareHeading = styled.h2`
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 24px;
  line-height: 33px;
`;

export const ShareInput = styled.input`
  width: 100%;
  margin: 0;
  padding: 18px 30px;
  padding-right: 110px;
  
  font-size: 16px;
  line-height: 1;
  
  border: 1px solid ${({ hasError, theme }) => hasError ? theme.red : '#ebebeb'};
  border-radius: 50px;
  background-color: transparent;
  outline: none;
  
  transition: border-color 0.3s;
  
  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.blue};
  }
`;

export const ShareInputContainer = styled.div`
  position: relative;
  
  margin-bottom: 30px;
  
  &:hover ${ShareInput} {
    border-color: ${({ theme }) => theme.blue};
  }
  
  ${ButtonTag} {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 4px;
    
    padding: 15px 30px;
  }
`;

export const ShareMessage = styled.p`
  position: absolute;
  bottom: -20px;
  left: 0;
  
  width: 100%;
  margin: 0;
  padding: 0;
  
  font-size: 14px;
  line-height: 1;
  color: ${({ theme, status }) => status === 'success' ? theme.green : theme.red};
  text-align: center;
`;

export const ShareList = styled.ul`
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  
  li > div {
    outline: none;
  }
  
  li:not(:last-child) {
    margin-right: 15px;
  }
`;

export const ShareButton = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  
  width: 32px;
  height: 32px;
  
  border-radius: 50%;
  outline: none;
  background-image: linear-gradient(135deg, #2DB9FE 0%, #4EDBFC 100%);
  box-shadow: 0 4px 16px rgba(30, 182, 255, 0.2);
  
  cursor: pointer;
  
  &:hover {
    background-image: none;
    border: 1px solid ${({ theme }) => theme.blue};
    
    svg {
      fill: ${({ theme }) => theme.blue};
    }
  }
  
  svg {
    fill: ${({ theme }) => theme.white};
  }
`;
